/* eslint-disable no-irregular-whitespace */
/* globals BS */

import axios from 'axios'
import DailySchedule from './DailySchedule'
import ScheduleMatomete from './ScheduleMatomete'
import getNewDailySchedule from './getNewDailySchedule'
import * as util from './util'

export default {
	name: 'MonthlySchedule',
	props: {
		mamanId: {
			type: Number,
			required: true
		},
		showOrders: {
			type: Boolean,
			default: false
		},
		guest: {
			type: Boolean,
			default: false
		},
		matometeEditable: {
			type: Boolean,
			default: false
		},
		date: {
			type: String,
			default: BS.Date.now.serializeDate()
		},
		appUrl: {
			type: String,
			required: true
		},
		validPost: {
			type: String,
			required: true
		},
		// 始まりの曜日
		dowBegins: {
			type: Number,
			default: 1
		}
	},
	data () {
		const date = new BS.Date(this.date)
		const year = date.getFullYear()
		const month = date.getMonth() + 1
		return {
			year: year,
			month: month,
			rows: [],
			selectedRow: null,
			selectedCol: null,
			isLoading: false,
			loadError: null,
			loadCancel: null,
			// 以下は編集時に使う
			matometeEditing: false,
			isModified: false,
			saveSuccess: false,
			saveError: null
		}
	},
	mounted () {
		this.updateMonth()
	},
	methods: {
		// ----------------------------------------------------------------
		// 読み込み・保存

		// スケジュールをサーバから読み込む
		load () {
			if (typeof this.loadCancel === 'function') {
				this.loadCancel()
			}
			this.isLoading = true
			this.loadError = null

			const url = `${this.appUrl}/maman/${this.mamanId}/schedule/${this.year}-${this.month}.json?v=${Date.now()}`
			axios.get(url, {
				// 通信を中断するための関数を用意
				cancelToken: new axios.CancelToken(c => { this.loadCancel = c })
			})
				.then(response => {
					this.didLoad(response.data)
				})
				.catch(error => {
					this.loadError = error.message
				})
		},

		didLoad (month) {
			let dayIndex = 0

			this.rows.forEach((row, rowIndex) => {
				row.cols.forEach((col, colIndex) => {
					var day = month.days[dayIndex]
					if (col.id !== day.id) {
						return
					}
					col.holiday = !!day.holiday
					day.divs.forEach((availableDiv) => {
						col.divs.forEach((div, divIndex) => {
							if (div.from >= availableDiv.from && div.to <= availableDiv.to) {
								this.rows[rowIndex].cols[colIndex].divs[divIndex].isActive = true
							}
						})
					})
					day.orders.forEach((order) => {
						col.divs.forEach((div, divIndex) => {
							if (div.from >= order.from && div.to <= order.to) {
								this.rows[rowIndex].cols[colIndex].divs[divIndex].hasOrder = true
							}
						})
					})
					this.$set(col, 'orders', day.orders)
					dayIndex++
				})
			})
		},

		// スケジュールをサーバに保存する
		save () {
			if (typeof this.loadCancel === 'function') {
				this.loadCancel()
			}

			const data = {
				year: this.year,
				month: this.month,
				days: []
			}
			this.rows.forEach((row) => {
				row.cols.forEach((col) => {
					if (col.out_of_month) {
						return
					}
					data.days.push({
						id: col.id,
						divs: this.combineDivs(col.divs)
					})
				})
			})

			this.saveSuccess = false
			this.saveError = null

			const url = `${this.appUrl}/maman/schedule/update.json`
			const postData = new URLSearchParams()
			postData.append('_VALIDPOST', this.validPost)
			postData.append('post', JSON.stringify(data))
			axios.post(url, postData, {
				// 通信を中断するための関数を用意
				cancelToken: new axios.CancelToken(c => { this.loadCancel = c })
			})
				.then(response => {
					this.isModified = false
					this.saveSuccess = true
				})
				.catch(error => {
					this.saveError = error.message
				})
		},

		combineDivs (divs) {
			var prevActive = false
			var combined = []
			divs.forEach(function (div) {
				if (div.isActive) {
					if (!prevActive) {
						combined.push({
							from: div.from,
							to: div.to
						})
					} else {
						combined[combined.length - 1].to = div.to
					}
				}
				prevActive = div.isActive
			})
			return combined
		},

		// ----------------------------------------------------------------
		// カレンダー

		// 前・次の月へ。スケジュールが更新されていれば確認する
		confirmSwitchMonth (monthName, switchFn) {
			var me = this
			if (!this.isModified) {
				switchFn.call(me)
				return
			}
			var dialog = new BS.Dialog(null, 'スケジュールが更新されています。' + monthName + 'へ移動する前に変更を保存しますか？', [
				{ label: '保存', value: 'yes', style: 'btn btn-primary' },
				{ label: '保存しない', value: 'no', style: 'btn btn-outline-secondary' },
				{ label: 'キャンセル', value: 'cancel', style: 'btn btn-outline-secondary' }
			])
			dialog.onhide = (value) => {
				switch (value) {
				case 'yes':
					this.save()
					switchFn.call(me)
					break
				case 'no':
					switchFn.call(me)
					break
				case 'cancel':
					break
				}
			}
			dialog.show()
		},

		// 前の月へ
		confirmPreviousMonth () {
			this.confirmSwitchMonth('前月', this.previousMonth)
		},

		// 次の月へ
		confirmNextMonth () {
			this.confirmSwitchMonth('翌月', this.nextMonth)
		},

		// 前の月へ
		previousMonth () {
			const prevMonth = new Date(this.year, this.month - 2, 1)
			this.year = prevMonth.getFullYear()
			this.month = prevMonth.getMonth() + 1
			this.unselect()
		},

		// 次の月へ
		nextMonth () {
			const nextMonth = new Date(this.year, this.month, 1)
			this.year = nextMonth.getFullYear()
			this.month = nextMonth.getMonth() + 1
			this.unselect()
		},

		// 月を変更したときのビューデータを更新する
		updateMonth () {
			var me = this
			this.$set(me, 'rows', this.createCalendarRows(this.year, this.month))
			this.load()
		},

		// 年・月のカレンダーのデータを生成する
		createCalendarRows (year, month) {
			var rows = []
			var cols = []
			var today = BS.Date.today
			var canReserveDate = today.modify({ day: 2 })
			var currentMonth = new Date(year, month - 1, 1)
			var nextMonth = new Date(year, month, 1)
			var p = new BS.Date(new Date(year, month - 1, 1 - ((currentMonth.getDay() + 7 - this.dowBegins) % 7)))
			var lim = new Date(year, month, 1 + ((7 - nextMonth.getDay() + this.dowBegins) % 7))
			while (p < lim) {
				cols.push({
					id: util.printDate(p),
					date: p.getDate(),
					dow: util.dayName(p),
					today: p.equals(today),
					past: (p < today),
					out_of_month: p < currentMonth || p >= nextMonth,
					canReserve: (p >= canReserveDate),
					selected: false,
					divs: getNewDailySchedule()
				})
				if (cols.length >= 7) {
					rows.push({
						cols: cols,
						selected: false
					})
					cols = []
				}
				p = p.modify({ day: 1 })
			}
			return rows
		},

		// 日ごとのスケジュールを閉じる
		unselect () {
			if (this.selectedCol) {
				this.selectedCol.selected = false
				this.selectedRow.selected = false
				this.selectedCol = null
				this.selectedRow = null
			}
		},

		// カレンダーをクリックしたときに、その日の予定を開く/閉じる
		toggleDailySchedule (dateId) {
			let selectedCol
			let selectedRow

			// 走査してクリックされた日を見つける
			this.rows.some((row) => {
				var matched = row.cols.some((col) => {
					if (col.id === dateId) {
						selectedCol = col
						return true
					}
					return false
				})
				if (matched) {
					selectedRow = row
					return true
				}
				return false
			})

			if (!selectedCol || selectedCol.out_of_month) {
				return
			}

			if (selectedCol.selected) {
				// 選択解除
				this.unselect()
				return
			}

			if (this.selectedCol) {
				this.selectedRow.selected = false
				this.selectedCol.selected = false
			}

			selectedCol.selected = true
			selectedRow.selected = true
			this.selectedCol = selectedCol
			this.selectedRow = selectedRow

			// 依頼フォームの日付を変更
			if (window.jsOrderRequestApp) {
				const date = selectedCol.canReserve ? selectedCol.id : null
				window.jsOrderRequestApp.setDate(date)
			}
		},

		// お仕事可能な時間帯があるかどうかを返す
		hasAvailableDiv (divs) {
			return divs.some((div) => {
				return div.isActive
			})
		},

		// ----------------------------------------------------------------
		// まとめて登録

		// まとめて登録ダイアログを開く
		matometeOpen () {
			this.unselect()
			this.matometeEditing = true
		},

		// まとめて登録ダイアログを閉じる
		matometeClose () {
			this.matometeEditing = false
		},

		// ダイアログに設定されたデータをもとに予定をまとめて登録する
		matometeApply (state) {
			this.matometeClose()
			this.rows.forEach((row) => {
				state.days.forEach((day) => {
					if (!day.isActive) {
						return
					}
					var col = row.cols[day.index]
					if (col.out_of_month || col.past) {
						return
					}
					state.divs.forEach((div, divIndex) => {
						col.divs[divIndex].isActive = div.isActive
					})
				})
			})
			this.isModified = true
		}
	},
	watch: {
		year () {
			this.updateMonth()
		},
		month () {
			this.updateMonth()
		}
	},
	filters: {
		time (timeStr) {
			return timeStr.replace(/^(0*)/, '')
		}
	},
	components: {
		DailySchedule,
		ScheduleMatomete
	},
	template: `
	<div class="monthly-schedule"
		:class="{ 'monthly-schedule-guest': guest, 'monthly-schedule-edit': matometeEditable }"
	>
		<div class="clearfix">
			<h4 class="left">{{ year }}年{{ month }}月</h4>
			<div class="btn-month mb-1">
				<span class="js-button" @click="confirmPreviousMonth">
					<span class="prev">前月</span>
				</span>　<span class="js-button" @click="confirmNextMonth">
					<span class="next">翌月</span>
				</span>
			</div>

			<div class="right t-calendar mgn-b10">
				<span class="day-work">お仕事可能日</span>
				<template v-if="showOrders">
					　<br class="sp" /><span class="t-request">依頼あり</span>
					　<span class="t-consent">承諾したお仕事</span>
					　<span class="t-done">完了したお仕事</span>
				</template>
				<template v-if="guest">
					<br>
					ママンのカレンダーの空いていない日も依頼する（打診・相談する）ことは可能です。
				</template>
			</div>
		</div>

		<template v-if="matometeEditable">
			<p class="mt-2 mb-2">
				<button type="button" class="btn btn-primary" @click="matometeOpen">まとめて登録</button>
			</p>
			<ScheduleMatomete
				v-if="matometeEditing"
				@apply="matometeApply"
				@cancel="matometeClose"
			/>
		</template>

		<div class="schedule-cal">
			<div class="cal-row cal-row-axis">
				<div class="cal-col">月</div>
				<div class="cal-col">火</div>
				<div class="cal-col">水</div>
				<div class="cal-col">木</div>
				<div class="cal-col">金</div>
				<div class="cal-col day-sat">土</div>
				<div class="cal-col day-sun">日</div>
			</div>
			<div v-for="row in rows" class="cal-row-group">
				<div class="cal-row cal-row-body">
					<div v-for="col in row.cols" :key="col.id" :data-id="col.id"
						class="cal-col" :class="['day-' + col.dow, {active: col.selected, today: col.today, past: col.past, holiday: col.holiday, 'cannot-reserve': !col.canReserve, 'out-of-month': col.out_of_month, 'can-work': hasAvailableDiv(col.divs), 'order-full': col.order_full}]"
						@click="toggleDailySchedule(col.id)">
						<span class="cal-day-circ">{{ col.date }}</span>
						<ul v-if="showOrders && col.orders" class="cal-day-statuses">
							<li v-for="order in col.orders" class="cal-day-status" :class="'cal-day-status-' + order.status">
								{{ order.from | time }}～{{ order.to | time }}
							</li>
						</ul>
					</div>
				</div>
				<transition>
					<div class="cal-row cal-row-daily-schedule" v-if="row.selected">
						<transition>
							<div class="cal-row-daily-schedule-inner" :key="selectedCol.id">
								<DailySchedule
									:day="selectedCol"
									:showOrders="showOrders"
									:matometeEditable="matometeEditable"
									:appUrl="appUrl"
									@scheduleChange="isModified = true"
								/>
							</div>
						</transition>
					</div>
				</transition>
			</div>
		</div>

		<div class="mt-3 mb-5" v-if="matometeEditable">
			<p class="small text-muted">時間を選択する際、連続で2時間以上を選択してください。</p>
			<p class="big text-center">
				<button type="button" class="btn-maman" :disabled="!isModified" @click="save">
					<template v-if="!isModified && saveSuccess">
						保存しました
					</template>
					<template v-else>
						保存する
					</template>
				</button>
			</p>
			<p v-if="saveError" class="mt-1 text-center text-danger">{{ saveError }}</p>
		</div>
	</div>
	`
}
